(function ($) {
/* eslint-disable */

    var $tableCrossHair = $('#table-crosshair');
    var $tableRadar = $('#table-radar');

    $tableCrossHair.DataTable({
        info: false,
        paging: false,
        searching: false,
        ordering: false,
        autoWidth: false
    });

    $tableRadar.DataTable({
        info: false,
        paging: false,
        searching: false,
        ordering: false,
        autoWidth: false
    });

})( jQuery );
